//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatImageCloudinary } from '~/helpers/image-helper';
export default {
  name: 'CommercialBanner',
  props: {
    image: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      opened: false
    };
  },

  computed: {
    currentImage() {
      return formatImageCloudinary(this.image);
    }

  },
  methods: {
    animate() {
      this.$nextTick(() => {
        this.opened = true;
      });
    }

  }
};